<template lang="pug">
	.version-assets-settings
		//VueModal(name="AssetsModal" classes="assets-modal" @closed="onModalClosed")
			.modal-tabs
				.modal-tab(v-for="(tabName, tabId) in modalTabs" :class="{'active-modal-tab': tabId === activeModalTab}" @click="setModalTab(tabId)") {{ addAssetTypesInfo[tabName].title }}
			.assets-modal-body
				.assets-modal-stack(v-if="modalTabs[activeModalTab] === 'stack'")
					.assets-modal-stack-list
						.assets-modal-stack-list-item(@click="selectStackValue(0)" :class="{'assets-modal-stack-list-item-active': isDefaultAsset}") {{ `Default "${currentAssetCodename}" value` }}
						// TODO: Сделать список всех загруженных ассетов
				.assets-modal-local-computer(v-if="modalTabs[activeModalTab] === 'localComputer'") Local Computer
				.assets-modal-google-fonts(v-if="modalTabs[activeModalTab] === 'googleFonts'")
					.assets-modal-google-fonts-description(v-html="addAssetTypesInfo[modalTabs[activeModalTab]].description")
					.assets-modal-google-fonts-input
						input(v-model="googleFontLink" type="text" placeholder="Put your link here")
					.assets-modal-google-fonts-button(:class="{'assets-modal-google-fonts-button-disabled': !isGoogleFontsLinkCorrect}" @click="setGoogleFont") ADD FONT
		.total-size
			span All Assets
			.assets-size
				AssetCompressionData(sizeText="Total size of assets: " :assetType="'all'" :assetCodenames="_.map(_.filter(projectVersionAssets, asset => ['image', 'atlas', 'sound', 'video', 'json', 'three-glb', 'three-fbx'].includes(asset.type) && (asset.type !== 'image' || !asset.options.atlases || asset.options.atlases.length === 0)), 'codename')")
		div(v-for="assetsGroup in assetsGroups")
			.asset-type.clearfix.mt-4(v-if="(assetsGroup.assets && assetsGroup.assets.length) || assetsGroup.isExtendable" :class="_.kebabCase(assetsGroup.type)")
				.asset-type-header
					.asset-type-title {{ assetsGroup.title }}
					.asset-type-add(v-if="assetsGroup.isExtendable" @click="addAsset(assetsGroup)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: assetsGroup.extendTitle}")
						i.fa.fa-plus
				.assets-size
					AssetCompressionData(:assetType="assetsGroup.type === 'font' ? 'web-font' : assetsGroup.type" :assetCodenames="_.map(_.filter(assetsGroup.assets, asset => asset.type !== 'image' || !asset.options.atlases || asset.options.atlases.length === 0), 'codename')")
				.progress.add-progress(:style="{visibility: assetsGroup.isUploading ? 'visible' : 'hidden'}")
					.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (assetsGroup.uploadProgress * 100) + '%'}")
				.asset-type-description
					small.text-muted(v-if="assetsGroup.assets && assetsGroup.assets.length" v-html="assetsGroup.description")
					small.text-muted(v-else v-html="assetsGroup.emptyText")
				.assets-list(v-if="assetsGroup.assets && assetsGroup.assets.length")
					.assets-list-item(v-for="asset in assetsGroup.assets" v-on:click="expandAsset(asset, $event)" :class="{'disabled': asset.Tags.disabled, 'expanded': expandedAssetCodename === asset.codename, [_.kebabCase(asset.codename)]: true}" @mouseover="onAssetOver(asset.codename, $event)" @mouseout="onAssetOut(asset.codename, $event)" v-pseudo-modal-name="'sound-asset-events-' + asset.id")
						.asset-list-main(:class="{'atlas-repack-disabled': assetsGroup.type === 'atlas' && asset.options && (asset.options.disable_repack_in_dashboard || asset.options.disableRepackInDashboard)}")
							.asset-list-name
								span.text-muted(v-if="asset.type === 'atlas' && asset.options['spritesAnimation']")
									i.fa.fa-film(style="margin-top: 2px") &nbsp;&nbsp;
								span {{ asset.title }}
								span.error(v-if="getAssetError(asset)") error
							.asset-list-edit
								.asset-list-edit-item(v-if="asset.isChanged && !asset.isRandom && !asset.Tags.custom")
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'This asset was changed'}")
								.asset-list-edit-item(v-if="asset.Tags.disabled")
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'This asset is disabled and not uses in the creative'}")
								.asset-list-edit-item(v-if="asset.isRandom")
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'This is random asset.\\nIt can`t be replaced.'}")
								.asset-list-edit-item.control-item.asset-list-edit-reset(v-if="asset.isChanged && !asset.isRandom && !asset.Tags.custom" @click="resetAsset(asset)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Reset to default'}")
									i.fa.fa-rotate-left
								.asset-list-edit-item.control-item.asset-list-edit-play(v-if="asset.type === 'sound'" @click="isPlaying(asset) ? stopSound(asset) : playSound(asset)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Play sound'}")
									i.fa(:class="{'fa-play-circle': !isPlaying(asset), 'fa-stop-circle': isPlaying(asset)}")
								.asset-list-edit-item.control-item.asset-list-edit-download(v-if="assetsGroup.isDownloadable && !asset.isRandom" @click="downloadAsset(asset)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Download asset'}")
									i.fa.fa-download
								.asset-list-edit-item.control-item.asset-list-edit-replace(v-if="assetsGroup.isReplaceable && !asset.isRandom" @click="replaceAsset(asset)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Replace asset'}")
									i.fa.fa-upload
								.asset-list-edit-item.control-item.asset-list-edit-replace-animation(v-if="asset.type === 'atlas'" @click="uploadIntoAtlas(asset)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: asset.options.spritesAnimation ? 'Replace animation sprites' : 'Upload images into atlas'}")
									i.fa.fa-upload
								.asset-list-edit-item.control-item.asset-list-edit-close(v-if="assetsGroup.isRemovable && isAssetsChangesAllowed" :class="{custom: asset.Tags.custom}" @click="removeAsset(assetsGroup, asset)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: asset.Tags.custom ? 'Delete asset' : (asset.Tags.disabled ? 'Enable asset' : 'Disable asset')}")
									i.fa(:class="{'fa-times': !asset.Tags.disabled, 'fa-refresh': asset.Tags.disabled}")
						.progress(v-if="asset.isUploading")
							.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (asset.uploadProgress * 100) + '%'}")
						.props-list(v-show="assetsGroup.type === 'sound' && expandedAssetCodename !== asset.codename")
							.prop-list(v-if="asset.hasPlayEvents") Play on&nbsp;
								.prop-name(v-for="chosen_event in asset.options.playOnEvents") {{chosen_event}}
									span ,&nbsp;
							.prop-list(v-if="asset.hasStopEvents") Stop on&nbsp;
								.prop-name(v-for="chosen_event in asset.options.stopOnEvents") {{chosen_event}}
									span ,&nbsp;
							.prop-list(v-if="asset.options.loop") loop
								.prop-name
									span ,&nbsp;
							.prop-list(v-if="asset.options.volume < 1") volume&nbsp;
								.prop-name {{asset.options.volume * 100}}%
									span ,&nbsp;
						.props-list(v-show="assetsGroup.type === 'video' && expandedAssetCodename !== asset.codename")
							.prop-list(v-if="asset.hasPlayEvents") Play on&nbsp;
								.prop-name(v-for="chosen_event in asset.options.playOnEvents") {{chosen_event}}
									span ,&nbsp;
							.prop-list(v-if="asset.hasStopEvents") Stop on&nbsp;
								.prop-name(v-for="chosen_event in asset.options.stopOnEvents") {{chosen_event}}
									span ,&nbsp;
							.prop-list(v-if="asset.options.loop") loop
								.prop-name
									span ,&nbsp;
							.prop-list(v-if="asset.options.volume < 1") volume&nbsp;
								.prop-name {{asset.options.volume * 100}}%
									span ,&nbsp;
						.asset-colors(v-if="assetsGroup.type === 'image' && asset.hasAtlas")
							.asset-color(v-for="atlas_name in asset.options.atlases" :style="{backgroundColor: Asset.getAtlasColor(projectVersionAssets[atlas_name])}")
						.asset-colors(v-if="assetsGroup.type === 'atlas'")
							.asset-color(:style="{backgroundColor: Asset.getAtlasColor(asset)}")
						.asset-list-item-settings
							.asset-settings.image-settings(v-if="assetsGroup.type === 'image' && expandedAssetCodename === asset.codename")
								.asset-settings-control.multi-select-control.in-a-row.low-margin.separated(v-if="!asset.hasAtlas")
									AssetCompressionData(:assetCodenames="[asset.codename]")
								.multi-select-control
									.multi-select-control-item(v-for="(chosen_atlas, index) in asset.options.atlases")
										span.title {{index === 0 ? (asset.options.atlases.length > 1 ? 'Assigned to atlases' : 'Assigned to atlas') : ''}}
										.custom-select.custom-select-sm.remove(v-if="atlases.length > 0" @click="unassignImageFromAtlas(asset, chosen_atlas)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Unassign image from atlas'}")
											span.fa.fa-remove
										.custom-select.custom-select-sm.selected(@click="openAtlasesDropdown(asset, 'atlases', index, $event)")
											span {{chosen_atlas}}
									.multi-select-control-item(v-if="Project.SelectedProject.type !== 'banner'")
										span.title {{asset.hasAtlas ? '' : (atlases.length > 0 ? 'This image has not been added to any atlas.' : 'Create an atlas asset to be able to move this image to the atlas.')}}
										.custom-select.custom-select-sm.add(v-if="atlases.length > 0" @click="openAtlasesDropdown(asset, 'atlases', false, $event)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Assign image to atlas'}")
											span.fa.fa-plus
								.asset-settings-control.compression-activated(v-if="!asset.hasAtlas && asset.isJPG")
									span.title {{asset.hasCompression ? 'Quality: ' + (parseInt(asset.options["compression"] * 100)) + '%' : 'Custom compression'}}
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" :checked="asset.hasCompression" @change="setImageAssetCompressionLevel(asset, $event.target.checked ? 80 : null)")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
								.asset-settings-control.compression-control(v-if="asset.hasCompression && !asset.hasAtlas && asset.isJPG")
									span.title
									input.custom-range(type="range" :min="1" :max="100" :step="1" :value="asset.options['compression'] * 100" v-on:input="setImageAssetCompressionLevel(asset, $event.target.value)")
								.asset-settings-control.compression-activated(v-if="!asset.hasAtlas && !asset.isGIF && !asset.isSVG")
									span.title Tinypng optimization
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" :checked="asset.options.tinyPng !== false" @change="setImageTinyPng(asset, $event.target.checked)")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
							.asset-settings.atlas-settings(v-if="assetsGroup.type === 'atlas' && expandedAssetCodename === asset.codename" :class="{'atlas-repack-disabled': asset.options && (asset.options.disable_repack_in_dashboard || asset.options.disableRepackInDashboard)}")
								.asset-settings-control.multi-select-control.in-a-row.low-margin.separated
									AssetCompressionData(:assetCodenames="[asset.codename]")
								.asset-settings-control.multi-select-control.in-a-row.low-margin
									span.title Atlas image format
									span
										select.custom-select.custom-select-sm(v-on:change="setAtlasFormat(asset, $event.target.value)")
											option(:selected="asset.options.atlasFormat === 'png'" value="png") PNG
											option(:selected="asset.options.atlasFormat === 'jpg'" value="jpg") JPG
								.asset-settings-control
									span.title Atlas scale: {{parseInt(asset.options["atlasScale"] * 100)}}%
									input.custom-range(type="range" :min="1" :max="100" :step="1" :value="asset.options.atlasScale * 100" v-on:input="setAtlasScale(asset, $event.target.value / 100)" style="width: 180px")
								.asset-settings-control
									span.title Atlas shape padding: {{parseInt(asset.options["atlasShapePadding"]) || 0}}px
									input.custom-range(type="range" :min="0" :max="10" :step="1" :value="asset.options.atlasShapePadding || 0" v-on:input="setAtlasShapePadding(asset, $event.target.value)" style="width: 180px")
								.asset-settings-control
									span.title Atlas extrude: {{getExtrudeValue(asset.options["atlasExtrude"])}}px
									input.custom-range(type="range" :min="0" :max="10" :step="1" :value="getExtrudeValue(asset.options.atlasExtrude)" v-on:input="setAtlasExtrude(asset, $event.target.value)" style="width: 180px")
								.asset-settings-control
									span.title Atlas trim mode: {{asset.options["atlasTrimMode"] || 'Trim'}}
									select.custom-select.custom-select-sm(v-on:change="setAtlasTrimMode(asset, $event.target.value)")
										option(:selected="asset.options.atlasTrimMode === 'Trim'" value="Trim") Trim
										option(:selected="asset.options.atlasTrimMode === 'Crop'" value="Crop") Crop
										option(:selected="asset.options.atlasTrimMode === 'None'" value="None") None
								.asset-settings-control.compression-activated
									span.title Allow rotation
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" :checked="asset.options.atlasRotation" @change="setAtlasRotation(asset, $event.target.checked)")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
								.asset-settings-control.compression-activated
									span.title Tinypng optimization
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" :checked="asset.options.atlasTinyPng" @change="setAtlasTinyPng(asset, $event.target.checked)")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
								.asset-settings-control.compression-activated(v-if="asset.options.atlasFormat === 'jpg' && !asset.options.atlasTinyPng")
									span.title {{asset.hasCompression ? 'Quality: ' + (parseInt(asset.options["compression"] * 100)) + '%' : 'Custom compression'}}
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" :checked="asset.hasCompression" @change="setImageAssetCompressionLevel(asset, $event.target.checked ? 80 : null)")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
								.asset-settings-control.compression-control(v-if="asset.options.atlasFormat === 'jpg' && !asset.options.atlasTinyPng && asset.hasCompression")
									span.title
									input.custom-range(type="range" :min="1" :max="100" :step="1" :value="asset.options['compression'] * 100" v-on:input="setImageAssetCompressionLevel(asset, $event.target.value)")
								.asset-settings-info(v-if="asset.options['spritesAnimation']" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Please include all sprites of single animation in separated atlas. In this case additional settings for the sprite animation will work correct. If you upload zip file into sprites animation atlas, all previous images inside it will be disabled.'}")
									i.icon-info.icons.font-2xl
									span.title This atlas is identified as a sprite animation.
								.asset-settings-control.sprites-animation-controls.low-margin(v-if="asset.options['spritesAnimation']")
									span.title
										span Animation speed:&nbsp;
										span(:ref="asset.codename + '-input-animationSpeed'") {{parseInt(asset.options["animationSpeed"] * 100)}}
										span %
									input.custom-range(type="range" :min="1" :max="500" :step="1" :value="asset.options['animationSpeed'] * 100" v-on:input="setAnimationSpeed(asset, $event.target.value / 100)" style="width: 180px")
								.asset-settings-control.sprites-animation-controls.low-margin(v-if="asset.options['spritesAnimation']")
									span.title
										span Animation scale:&nbsp;
										span(:ref="asset.codename + '-input-animationScale'") {{parseInt((asset.options["animationScale"] || 1) * 100)}}
										span %
									input.custom-range(type="range" :min="1" :max="500" :step="1" :value="asset.options['animationScale'] * 100" v-on:input="setAnimationScale(asset, $event.target.value / 100)" style="width: 180px")
								.asset-settings-control.sprites-animation-controls.low-margin(v-if="asset.options['spritesAnimation']")
									span.title Animation anchor:
									.control-point
										.control-point-input
											label(v-on:wheel="changeAssetOptionByMouseWheel(asset, 'animationAnchor', 0, $event)")
												.label x
												input.form-control.form-control-sm(:ref="asset.codename + '-input-animationAnchor-0'" :value="asset.options['animationAnchor'][0]" v-on:keydown="startChangeValueByKeyPress(asset, 'animationAnchor', 0, $event)" v-on:change="setAssetOptionValue(asset, 'animationAnchor', 0, parseFloat($event.target.value))")
										.control-point-input
											label(v-on:wheel="changeAssetOptionByMouseWheel(asset, 'animationAnchor', 1, $event)")
												.label y
												input.form-control.form-control-sm(:ref="asset.codename + '-input-animationAnchor-1'" :value="asset.options['animationAnchor'][1]" v-on:keydown="startChangeValueByKeyPress(asset, 'animationAnchor', 1, $event)" v-on:change="setAssetOptionValue(asset, 'animationAnchor', 1, parseFloat($event.target.value))")
							.asset-settings.sound-settings(v-if="assetsGroup.type === 'sound' && expandedAssetCodename === asset.codename")
								.asset-settings-control.multi-select-control.in-a-row.low-margin.separated
									AssetCompressionData(:assetCodenames="[asset.codename]")
								.asset-settings-control.multi-select-control
									.multi-select-control-item(v-for="(chosen_event, index) in asset.options.playOnEvents")
										span.title {{index === 0 ? (asset.options.playOnEvents.length > 1 ? 'Play on events' : 'Play on event') : ''}}
										.custom-select.custom-select-sm.selected(@click="openEventsDropdown(asset, 'playOnEvents', index, $event)")
											span {{chosen_event}}
									.multi-select-control-item
										span.title {{asset.hasPlayEvents ? '' : 'This sound didn\'t played on any event'}}
										.custom-select.custom-select-sm.add(@click="openEventsDropdown(asset, 'playOnEvents', false, $event)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Assign event to play'}")
											span.fa.fa-plus
								.asset-settings-control.multi-select-control
									.multi-select-control-item(v-for="(chosen_event, index) in asset.options.stopOnEvents")
										span.title {{index === 0 ? (asset.options.stopOnEvents.length > 1 ? 'Stop on events' : 'Stop on event') : ''}}
										.custom-select.custom-select-sm.selected(@click="openEventsDropdown(asset, 'stopOnEvents', index, $event)")
											span {{chosen_event}}
									.multi-select-control-item
										span.title {{asset.hasStopEvents ? '' : 'This sound didn\'t stopped on any event'}}
										.custom-select.custom-select-sm.add(@click="openEventsDropdown(asset, 'stopOnEvents', false, $event)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Assign event to stop'}")
											span.fa.fa-plus
								.asset-settings-control.loop
									span.title Loop
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" :checked="asset.options.loop" @change="setSoundLoop(asset, $event.target.checked)")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
								.asset-settings-control.volume-control
									span.title Volume {{ parseInt((asset.options.volume || 1) * 100) }}%
									input.custom-range(type="range" :min="1" :max="100" :step="1" :value="(asset.options.volume || 1) * 100" v-on:input="setSoundVolume(asset, $event.target.value)")
								.asset-settings-control.bitrate
									span.title Bitrate {{ asset.options.bitrate || 64 }}kbps
									input.custom-range(type="range" :min="32" :max="128" :step="1" :value="asset.options.bitrate || 64" v-on:input="setSoundBitrate(asset, $event.target.value)")
							.asset-settings.video-settings(v-if="assetsGroup.type === 'video' && expandedAssetCodename === asset.codename")
								.asset-settings-control.multi-select-control.in-a-row.low-margin(:class="allowVideoCompression ? 'separated' : 'separated-top'")
									AssetCompressionData(:assetCodenames="[asset.codename]")
								.asset-compression-controls(v-if="allowVideoCompression")
									.asset-settings-control.bitrate
										span.title Video bitrate {{ asset.options.videoBitrate || 2048 }}kbps
										input.custom-range(type="range" :min="256" :max="4096" :step="32" :value="asset.options.videoBitrate || 2048" v-on:input="setVideoVideoBitrate(asset, $event.target.value)")
									.asset-settings-control.jsmpeg
										span.title Software rendering (jsmpeg)
										label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
											input.switch-input.form-check-input(type="checkbox" :checked="asset.options.jsmpeg" @change="setVideoJSMPEG(asset, $event.target.checked)")
											span.switch-slider(data-checked="On" data-unchecked="Off")
											span.switch-handle
									.asset-settings-control.bitrate
										span.title Audio bitrate {{ asset.options.audioBitrate || 128 }}kbps
										input.custom-range(type="range" :min="32" :max="384" :step="32" :value="asset.options.audioBitrate || 128" v-on:input="setVideoAudioBitrate(asset, $event.target.value)")
									.asset-settings-control.audio-channels
										span.title Stereo sound
										label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
											input.switch-input.form-check-input(type="checkbox" :checked="asset.options.audioStereo !== false" @change="setVideoAudioStereo(asset, $event.target.checked)")
											span.switch-slider(data-checked="On" data-unchecked="Off")
											span.switch-handle

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Project } 			from './../../services/Project'
	import { Version }			from './../../services/Version'
	import { Asset } 			from './../../services/Asset'
	import { Notifications } 	from './../../services/Notifications'
	import { Monitoring } 		from './../../services/Monitoring'

	import AssetCompressionData from './../Templates/AssetCompressionData'

	export default {
		name: "VersionAssetsSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Changed",
				"Settings Tab Changed:assets",
				"Asset Upload Progress",
				"Selected Project Compression Data Changed",
				"Selected Version Asset Added",
				"Selected Version Assets Changed",
				"Selected Version Assets Restored",
				"Selected Version Assets Deleted",
				"Selected Version Setting Changed:asset-video-compression"
			],
			events: {
				"Pseudo Modal Process Hide": function(names) {

					if (!this.expandedAssetCodename) return;
					if (!_.find(names, n => n.indexOf('sound-asset-events-') === 0) && !_.includes(names, 'items-dropdown')) this.collapseAsset();

				}
			}
		},
		components: {
			AssetCompressionData
		},
		data() {

			this.Project = Project;
			this.Asset = Asset;
			this.Monitoring = Monitoring;

			this.events = [];
			this.allowVideoCompression = true;
			this.atlases = [];

			this.addAssetTypesInfo = {
				stack: {
					title: 'Uploaded Files'
				},
				localComputer: {
					title: 'Your Computer'
				},
				googleFonts: {
					title: 'Google Fonts',
					description: 'Here you can add <a href="https://fonts.google.com/" target="_blank">google font</a>. For Example to add "Roboto" font you should use "<span>https://fonts.googleapis.com/css?family=Roboto&display=swap</span>" link'
				}
			};

			this.assetsGroups = {};

			this.projectVersionAssets = {};

			this.dragProcess = null;

			return {
				showed: true,
				modalTabs: [],
				activeModalTab: 0,
				googleFontLink: '',
				currentAssetType: null,
				currentAssetId: null,
				isAssetsChangesAllowed: false,
				expandedAssetCodename: null,
				soundAssetEventDropdownIndex: 0
			};

		},
		computed: {
			isGoogleFontsLinkCorrect() {

				const link = this.googleFontLink.trim();
				return !!link.match(/^https:\/\/fonts\.googleapis\.com\/css\?family=(\w|\+|&|=)+$/);

			},
			isDefaultAsset() {

				return this.currentAssetType && this.currentAssetType.assets[this.currentAssetId] && this.currentAssetType.assets[this.currentAssetId].asset_url === this.currentAssetType.assets[this.currentAssetId].params.url;

			},
			currentAssetCodename() {

				if (this.currentAssetType && this.currentAssetType.assets[this.currentAssetId]) return this.currentAssetType.assets[this.currentAssetId].codename;
				else return '';

			}
		},
		mounted() {

			window.addEventListener("keyup", e => {

				if (this.keyPressProcess && (e.keyCode === 38 || e.keyCode === 40)) this.stopChangeValueByKeyPress();

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = false;
					if (this.dragProcess) this.dragProcess.shiftKey = false;
					if (this.rotateProcess) this.rotateProcess.shiftKey = false;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = false;
					if (this.dragProcess) this.dragProcess.ctrlKey = false;
					if (this.rotateProcess) this.rotateProcess.ctrlKey = false;

					this.update();

				}

			});

		},
		methods: {
			collectData() {

				if (!Project.SelectedProject) return;

				if ((Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') && !Settings.getSettingValue('track-events')) return;

				this.events = Settings.getSettingValue('track-events') || [];
				this.allowVideoCompression = Settings.getSettingValue('asset-video-compression');
				this.atlases = [];

				this.projectVersionAssets =  Asset.getVersionAssets(Version.SelectedVersion);

				if (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') {

					this.assetsGroups = {
						'image': {
							type: 'image',
							title: 'Images',
							description: 'Here you can replace playable images',
							isRemovable: true, // Возможно ли отключить ассет
							isExtendable: true, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: true, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'atlas': {
							type: 'atlas',
							title: 'Atlases',
							extendTitle: 'Add new atlas',
							emptyText: 'There are no atlases in the creative. You can add one and assign images to it.',
							description: 'Here you can edit atlases settings',
							isRemovable: true, // Возможно ли отключить ассет
							isExtendable: true, // Возможно ли добавить новый ассет
							isReplaceable: false, // Возможно ли заменить ассет
							isDownloadable: false, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'three-fbx': {
							type: 'three-fbx',
							title: 'FBX 3D models',
							extendTitle: 'Add new fbx model',
							emptyText: 'There are no fbx assets in the creative.',
							description: 'Here you can replace fbx models',
							isRemovable: false, // Возможно ли отключить ассет
							isExtendable: false, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: true, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'three-glb': {
							type: 'three-glb',
							title: 'GLB 3D models',
							extendTitle: 'Add new glb model',
							emptyText: 'There are no glb assets in the creative.',
							description: 'Here you can replace glb models',
							isRemovable: false, // Возможно ли отключить ассет
							isExtendable: false, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: true, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'sound': {
							type: 'sound',
							title: 'Sounds',
							extendTitle: 'Add sound asset',
							emptyText: 'There are no sound assets in the creative. You can add one and specify event to play.',
							description: 'Here you can replace, remove or add new sounds. Note that sounds can be played and stopped programmatically, not only on specified here events.',
							isRemovable: true, // Возможно ли отключить ассет
							isExtendable: true, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: true, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'video': {
							type: 'video',
							title: 'Videos',
							extendTitle: 'Add video asset',
							emptyText: 'There are no video assets in the creative.',
							description: 'Here you can replace videos.',
							isRemovable: false, // Возможно ли отключить ассет
							isExtendable: false, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: true, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'json': {
							type: 'json',
							title: 'Data',
							extendTitle: 'Add json asset',
							emptyText: 'There are no json assets in the creative.',
							description: 'Here you can replace json data files.',
							isRemovable: false, // Возможно ли отключить ассет
							isExtendable: false, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: true, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'web-font': {
							type: 'font',
							title: 'Fonts',
							description: 'Here you can add <a href="https://fonts.google.com/" target="_blank">google fonts</a> or disable preloaded fonts',
							isRemovable: true, // Возможно ли отключить ассет
							isExtendable: false, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: false, // Возможно ли скачать ассет
							assetAddTypes: [/*'stack', 'localComputer', */'googleFonts', 'stack']
						}
					};

				} else if (Project.SelectedProject.type === 'banner') {

					this.assetsGroups = {
						'image': {
							type: 'image',
							title: 'Images',
							description: 'Here you can replace playable images',
							isRemovable: true, // Возможно ли отключить ассет
							isExtendable: true, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: true, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'video': {
							type: 'video',
							title: 'Videos',
							extendTitle: 'Add video asset',
							emptyText: 'There are no video assets in the creative.',
							description: 'Here you can replace videos.',
							isRemovable: true, // Возможно ли отключить ассет
							isExtendable: true, // Возможно ли добавить новый ассет
							isReplaceable: true, // Возможно ли заменить ассет
							isDownloadable: true, // Возможно ли скачать ассет
							assetAddTypes: []
						},
						'web-font': {
							type: 'font',
							title: 'Fonts',
							description: 'Here you can add <a href="https://fonts.google.com/" target="_blank">google fonts</a> or disable preloaded fonts',
							isRemovable: true, // Возможно ли отключить ассет
							isExtendable: false, // Возможно ли добавить новый ассет
							isReplaceable: false, // Возможно ли заменить ассет
							isDownloadable: false, // Возможно ли скачать ассет
							assetAddTypes: [/*'stack', 'localComputer', */'googleFonts', 'stack']
						}
					};

				}

				_.each(this.assetsGroups, config => {
					config.assets = [];
				});

				_.each(this.projectVersionAssets, asset => {

					if (this.assetsGroups[asset.type]) {

						if (asset.type === 'atlas') {

							this.assetsGroups[asset.type].assets.push(asset);
							this.atlases.push({name: asset.codename});

						} else {

							if (!asset.options.isHidden) this.assetsGroups[asset.type].assets.push(asset);

						}

					}

				});

				if (Version.SelectedVersion) this.isAssetsChangesAllowed = !Version.SelectedVersion.Tags.base || User.currentUser.Tags['admin'];

			},
			addAsset(assetsGroup) {

				if (assetsGroup.type === 'atlas') {

					Asset.createAtlas();

				} else {

					Asset.uploadAsset(assetsGroup.type, file => {

						Asset.addAsset(assetsGroup, file);

					});

				}

			},
			downloadAsset(asset) {

				Asset.downloadAsset(asset);

			},
			replaceAsset(asset) {

				if (!this.isAssetsChangesAllowed) {
					Broadcast.call("Show AssetReplaceNotAllowedPopUp");
					return;
				}

				Asset.uploadAsset(asset.type, file => {

					Asset.replaceAsset(asset, file);

					if (Asset.audioInstances[`${asset['version_id']}-${asset.codename}`]) delete Asset.audioInstances[`${asset['version_id']}-${asset.codename}`];

				});

			},
			uploadIntoAtlas(asset) {

				Asset.uploadAsset("zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed,image/png,image/jpeg", file => {

					Asset.uploadIntoAtlas(asset, file);

				});

			},
			resetAsset(asset) {

				Server.sendToSocket({
					ResetAsset: {
						versionId: asset['version_id'],
						assetCodename: asset['codename']
					}
				});

			},
			playSound(asset) {

				if (!Asset.audioInstances[`${asset['version_id']}-${asset.codename}`]) {

					let url = Asset.getAssetActualUrl(asset, {addTimestamp: true});

					let audioInstance = new Audio(url);
					audioInstance.addEventListener('play', () => {
						audioInstance.isPlaying = true;
						this.update();
					});
					audioInstance.addEventListener('ended', () => {
						audioInstance.isPlaying = false;
						this.update();
					});

					Asset.audioInstances[`${asset['version_id']}-${asset.codename}`] = audioInstance;

				}

				Asset.audioInstances[`${asset['version_id']}-${asset.codename}`].play();

			},
			stopSound(asset) {

				if (Asset.audioInstances[`${asset['version_id']}-${asset.codename}`]) {

					Asset.audioInstances[`${asset['version_id']}-${asset.codename}`].pause();
					Asset.audioInstances[`${asset['version_id']}-${asset.codename}`].currentTime = 0;
					Asset.audioInstances[`${asset['version_id']}-${asset.codename}`].isPlaying = false;

					//Нужно если меняется битрейт
					Asset.audioInstances[`${asset['version_id']}-${asset.codename}`] = null;

					this.update();

				}

			},
			getAudioInstance(asset) {

				return Asset.audioInstances[`${asset['version_id']}-${asset.codename}`]

			},
			isPlaying(asset) {

				let audioInstance = this.getAudioInstance(asset);

				return audioInstance && audioInstance.isPlaying

			},
			onAssetOver(assetCodename, e) {

				Broadcast.call("Show Asset Preview", [Asset.getAsset(Version.SelectedVersion, assetCodename), e, e.currentTarget]);

			},
			onAssetOut(assetCodename, e) {

				Broadcast.call("Hide Asset Preview", [Asset.getAsset(Version.SelectedVersion, assetCodename), e, e.currentTarget]);

			},
			removeAsset(assetConfig, asset) {

				if (asset.Tags.custom) {

					Server.sendToSocket({
						RemoveAsset: {
							versionId: asset['version_id'],
							assetCodename: asset.codename
						}
					});

				} else {

					if (asset.Tags.disabled) {

						Server.sendToSocket({
							EnableAsset: {
								versionId: asset['version_id'],
								assetCodename: asset.codename
							}
						});

					} else {

						Server.sendToSocket({
							DisableAsset: {
								versionId: asset['version_id'],
								assetCodename: asset.codename
							}
						});

					}

				}

			},
			expandAsset(asset, event) {

				if (event.target.closest('.asset-list-main .asset-list-edit')) return;

				this.expandedAssetCodename = asset.codename;

			},
			collapseAsset() {

				this.expandedAssetCodename = null;

			},
			setImageTinyPng(asset, tiny_png) {

				Asset.setAssetProperty(asset, 'tinyPng', tiny_png);

			},

			setImageAssetCompressionLevel(asset, level) {

				if (level === null) {
					delete asset.options.compression;
					asset.hasCompression = false;
				} else {
					asset.options.compression = parseInt(level) / 100;
					asset.hasCompression = true;
				}

				clearTimeout(this.setCompressionLevelTimeout);
				this.setCompressionLevelTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'compression', level === null ? null : parseInt(level) / 100);

				}, 200);

				this.update();

			},
			openEventsDropdown(asset, property, place, event) {

				if (place === false) place = asset.hasPlayEvents ? asset.options[property].length : 0;

				this.soundAssetEventDropdownProperty = property;
				this.soundAssetEventDropdownIndex = place;

				let items = _.clone(this.events);
				items.push({name: false, title: (asset.hasPlayEvents && asset.options[property][place]) ? 'Remove' : 'Cancel', className: 'bg-danger'});

				Broadcast.call("Show ItemsDropdown", [event.target.closest('.custom-select'), items, {title: 'Assign event'}, (event_name) => {

					if (event_name) this.assignSoundToEvent(asset, event_name);
					else this.unassignSoundFromEvent(asset, asset.options[property][this.soundAssetEventDropdownIndex])

				}]);

			},
			assignSoundToEvent(asset, event_name) {

				if (!asset.options[this.soundAssetEventDropdownProperty]) asset.options[this.soundAssetEventDropdownProperty] = [];

				if (asset.options[this.soundAssetEventDropdownProperty][this.soundAssetEventDropdownIndex]) {

					if (this.soundAssetEventDropdownIndex <= asset.options[this.soundAssetEventDropdownProperty].length) asset.options[this.soundAssetEventDropdownProperty][this.soundAssetEventDropdownIndex] = event_name;

				} else {

					asset.options[this.soundAssetEventDropdownProperty].push(event_name);

				}

				Asset.setAssetProperty(asset, this.soundAssetEventDropdownProperty, asset.options[this.soundAssetEventDropdownProperty]);

				Broadcast.call("Items Dropdown Hide");

			},
			unassignSoundFromEvent(asset, event_name) {

				_.pull(asset.options[this.soundAssetEventDropdownProperty], event_name);

				Asset.setAssetProperty(asset, this.soundAssetEventDropdownProperty, asset.options[this.soundAssetEventDropdownProperty]);

				Broadcast.call("Items Dropdown Hide");

			},
			setSoundVolume(asset, volume) {

				asset.options.volume = parseInt(volume) / 100;

				clearTimeout(this.setSoundVolumeTimeout);
				this.setSoundVolumeTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'volume', parseInt(volume) / 100);

				}, 200);

				this.update();

			},
			setVideoVolume(asset, volume) {

				asset.options.volume = parseInt(volume) / 100;

				clearTimeout(this.setSoundVolumeTimeout);
				this.setSoundVolumeTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'volume', parseInt(volume) / 100);

				}, 200);

				this.update();

			},
			setSoundLoop(asset, value) {

				Asset.setAssetProperty(asset, 'loop', value);

			},
			setVideoLoop(asset, value) {

				Asset.setAssetProperty(asset, 'loop', value);

			},
			setSoundBitrate(asset, value) {

				asset.options.bitrate = value;

				clearTimeout(this.setSoundBitrateTimeout);
				this.setSoundBitrateTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'bitrate', value);

				}, 200);

				this.update();

			},
			setVideoVideoBitrate(asset, videoBitrate) {

				asset.options.videoBitrate = videoBitrate;

				clearTimeout(this.setVideoVideoBitrateTimeout);
				this.setVideoVideoBitrateTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'videoBitrate', videoBitrate);

				}, 200);

				this.update();

			},
			setVideoAudioBitrate(asset, audioBitrate) {

				asset.options.audioBitrate = audioBitrate;

				clearTimeout(this.setVideoAudioBitrateTimeout);
				this.setVideoAudioBitrateTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'audioBitrate', audioBitrate);

				}, 200);

				this.update();

			},
			setVideoJSMPEG(asset, isJsmpeg) {

				asset.options.jsmpeg = !!isJsmpeg;

				clearTimeout(this.setVideoJsmpegTimeout);
				this.setVideoJsmpegTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'jsmpeg', !!isJsmpeg);

				}, 200);

				this.update();

			},
			setVideoAudioStereo(asset, isStereo) {

				asset.options.audioStereo = !!isStereo;

				clearTimeout(this.setVideoAudioStereoTimeout);
				this.setVideoAudioStereoTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'audioStereo', !!isStereo);

				}, 200);

				this.update();

			},
			openAtlasesDropdown(asset, property, place, event) {

				if (place === false) place = asset.hasAtlas ? asset.options['atlases'].length : 0;

				let items = _.clone(this.atlases);

				//items.push({name: 'create', title: 'Create new atlas', className: 'bg-green'});
				//items.push({name: false, title: (asset.hasAtlas && asset.options['atlases'][place]) ? 'Remove' : 'Cancel', className: 'bg-danger'});

				Broadcast.call("Show ItemsDropdown", [event.target.closest('.custom-select'), items, {title: 'Assign to atlas', height: 300}, (item_name) => {

					if (item_name) this.assignImageToAtlas(asset, item_name, place);
					else if (asset.hasAtlas) this.unassignImageFromAtlas(asset, asset.options['atlases'][place])

				}]);

			},
			assignImageToAtlas(asset, event_name, place) {

				if (!asset.options['atlases']) asset.options['atlases'] = [];

				if (asset.options['atlases'][place]) {

					if (place <= asset.options['atlases'].length) asset.options['atlases'][place] = event_name;

				} else {

					asset.options['atlases'].push(event_name);

				}

				Asset.setAssetProperty(asset, 'atlases', asset.options['atlases']);

				Broadcast.call("Items Dropdown Hide");

			},
			unassignImageFromAtlas(asset, atlas_name) {

				_.pull(asset.options['atlases'], atlas_name);

				Asset.setAssetProperty(asset, 'atlases', asset.options['atlases']);

				Broadcast.call("Items Dropdown Hide");

			},
			setAtlasFormat(asset, format) {

				Asset.setAssetProperty(asset, 'atlasFormat', format);

			},
			setAtlasOpt(asset, opt) {

				Asset.setAssetProperty(asset, 'atlasOpt', opt);

			},
			setAtlasDitherType(asset, dither) {

				Asset.setAssetProperty(asset, 'atlasDitherType', dither);

			},
			setAtlasScale(asset, scale) {

				Asset.setAssetProperty(asset, 'atlasScale', scale);

			},
			setAtlasShapePadding(asset, shapePadding) {

				Asset.setAssetProperty(asset, 'atlasShapePadding', shapePadding);

			},
			setAtlasExtrude(asset, shapePadding) {

				Asset.setAssetProperty(asset, 'atlasExtrude', shapePadding);

			},
			getExtrudeValue(value) {

				if (typeof value !== 'undefined' && typeof parseInt(value) === 'number') {
					return parseInt(value);
				} else return 1;

			},
			setAtlasTrimMode(asset, trimMode) {

				Asset.setAssetProperty(asset, 'atlasTrimMode', trimMode);

			},
			setAtlasRotation(asset, trimMode) {

				Asset.setAssetProperty(asset, 'atlasRotation', trimMode);

			},
			setAtlasTinyPng(asset, tiny_png) {

				Asset.setAssetProperty(asset, 'atlasTinyPng', tiny_png);

			},
			setAnimationSpeed(asset, speed) {

				speed = Math.round((speed * 100) / 5) * 5 / 100;

				this.setAssetOptionValue(asset, 'animationSpeed', null, speed, Math.round(speed * 100));

			},
			setAnimationScale(asset, scale) {

				scale = Math.round((scale * 100) / 5) * 5 / 100;

				this.setAssetOptionValue(asset, 'animationScale', null, scale, Math.round(scale * 100));

			},
			startChangeValueByKeyPress(asset, optionName, optionProp, e) {

				if (e.keyCode === 38 || e.keyCode === 40) {

					if (!this.keyPressProcess) {

						this.keyPressProcess = {
							asset,
							optionName,
							optionProp,
							increaser: (e.keyCode === 40 ? -1 : 1),
							shiftKey: e.shiftKey
						};

						this.keyPressProcess.timeout = setTimeout(() => {

							this.changeAssetOptionValue(this.keyPressProcess.asset, this.keyPressProcess.optionName, this.keyPressProcess.optionProp, this.keyPressProcess.increaser * (this.keyPressProcess.increaser.shiftKey ? 0.1 : 0.01));

							this.keyPressProcess.interval = setInterval(() => {

								this.changeAssetOptionValue(this.keyPressProcess.asset, this.keyPressProcess.optionName, this.keyPressProcess.optionProp, this.keyPressProcess.increaser * (this.keyPressProcess.increaser.shiftKey ? 0.1 : 0.01));

							}, 50);

						}, 200);

						this.changeAssetOptionValue(this.keyPressProcess.asset, this.keyPressProcess.optionName, this.keyPressProcess.optionProp, this.keyPressProcess.increaser * (this.keyPressProcess.increaser.shiftKey ? 0.1 : 0.01));

					}

					e.preventDefault();

				}

			},
			stopChangeValueByKeyPress() {

				if (this.keyPressProcess) {

					clearTimeout(this.keyPressProcess.timeout);
					clearInterval(this.keyPressProcess.interval);
					clearTimeout(this.keyPressProcess.stopTimeout);

					this.keyPressProcess = null;

				}

			},
			changeAssetOptionByMouseWheel(asset, optionName, optionProp, e) {

				this.changeAssetOptionValue(asset, optionName, optionProp, Math.sign(e.wheelDelta) * (e.shiftKey ? 0.1 : 0.01));

				e.preventDefault();

			},
			changeAssetOptionValue(asset, optionName, optionProp, increaser) {

				let optionValue = asset.options[optionName];

				if (optionProp === null) this.setAssetOptionValue(asset, optionName, optionProp, optionValue + increaser);
				else this.setAssetOptionValue(asset, optionName, optionProp, optionValue[optionProp] + increaser);

			},
			setAssetOptionValue(asset, optionName, optionProp, value, valueStr = null) {

				let optionValue = asset.options[optionName],
					el;

				if (optionProp === null) {
					optionValue = value;
					el = this.$refs[`${asset.codename}-input-${optionName}`][0];
				} else {
					optionValue[optionProp] = value;
					el = this.$refs[`${asset.codename}-input-${optionName}-${optionProp}`][0];
				}

				if (el) {
					if ("value" in el) el.value = valueStr || value;
					else if ("innerText" in el) el.innerText = valueStr || value;
					else if ("nodeValue" in el) el.nodeValue = valueStr || value;
				}

				Asset.setAssetProperty(asset, optionName, optionValue);

			},
			selectAsset(assetConfig, assetId) {

				if (!assetConfig.assetAddTypes || !assetConfig.assetAddTypes.length) return;

				this.currentAssetId = assetId;

				this.openModal(0, assetConfig);

			},
			openModal(tabId, assetConfig) {

				this.currentAssetType = assetConfig;

				this.$modal.show('AssetsModal');

				this.modalTabs = assetConfig.assetAddTypes;

			},
			setModalTab(id) {

				this.activeModalTab = id;

			},
			setGoogleFont() {

				if (!this.isGoogleFontsLinkCorrect) return Notifications.showError(`Invalid google font link!`);

				const link = this.googleFontLink.trim();

				if (this.currentAssetId === null) { // Если добавляется новый шрифт


				} else { // Изменяется старый

					Asset.updateAsset(this.currentAssetType.assets[this.currentAssetId].codename, link);

					Notifications.showSuccess(`Font successfully changed!\nPlease reload creative.`);

				}

				this.googleFontLink = '';

				this.$modal.hide('AssetsModal');

			},
			onModalClosed() {

				this.currentAssetType = null;
				this.currentAssetId = null;

			},
			selectStackValue(id) {

				if (id === 0) { // default

					if (this.isDefaultAsset) return;

					Asset.updateAsset(this.currentAssetType.assets[this.currentAssetId].codename, this.currentAssetType.assets[this.currentAssetId].params.url);

					Notifications.showSuccess(`Asset successfully changed!\nPlease reload creative.`);

				}

			},
			getAssetError(asset) {

				let error = null;

				if (asset.options.atlases) {

					_.each(asset.options.atlases, atlasAssetCodename => {

						let atlasAsset = this.projectVersionAssets[atlasAssetCodename];
						let compressionData = Asset.CompressionCacheData[atlasAsset['project_id']]?.[atlasAsset.cacheKey];

						if (compressionData?.error) error = compressionData.error;

					})

				}

				return error;

			}
		}
	}
</script>

<style lang="sass">

	aside.aside-menu .version-assets-settings hr
		margin-top: 0.3rem
		margin-bottom: 0.3rem

	.version-assets-settings

		.total-size
			margin-top: 20px

		a
			color: #20a8d8
			text-decoration: none
			background-color: transparent
			transition: 0.2s

			&:hover
				color: #2080af
				text-decoration: none

		.assets-list-empty
			padding: 5px
			color: #73818f

		.assets-list
			position: relative
			margin-top: 5px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden

			.assets-list-item
				position: relative
				user-select: none
				min-height: 25px

				&:not(:first-child)
					border-top: 1px solid rgba(0, 0, 0, 0.1)

				&:hover
					background-color: #2f363c

				.asset-list-main
					display: flex
					position: relative
					justify-content: space-between
					border-top: 1px solid #23282c
					cursor: pointer
					transition: 0.2s
					user-select: none

					&.atlas-repack-disabled
						opacity: 0.5

					&:first-child
						border-top: none

					.asset-list-name
						padding: 5px 0 5px 5px
						max-width: 170px
						overflow: hidden
						text-overflow: ellipsis
						white-space: nowrap
						display: flex
						flex-direction: row

						span
							line-height: 14px
							display: flex
							white-space: nowrap
							text-overflow: ellipsis
							overflow: hidden
							height: 15px

							&.error
								color: #f86c6b
								margin-left: 10px

					.asset-list-edit
						display: flex

						.icon-info
							color: #20a8d8
							font-size: 0.8rem !important
							display: inline-block
							margin-top: 5px

				.progress
					position: absolute
					height: 3px
					bottom: 0
					width: 100%
					background-color: rgba(255,255,255,0.1)
					border-radius: 0

				.props-list
					max-width: 94%
					display: flex
					flex-wrap: wrap
					font-size: 10px
					color: #73818f
					padding-left: 5px
					margin-top: -3px
					cursor: pointer

					.prop-list
						display: flex
						white-space: nowrap

						.prop-name
							display: flex
							white-space: nowrap

					.prop-list:last-child

						.prop-name:last-child

							span
								display: none

					.prop-list:not(:first-child)
						text-transform: lowercase

						.prop-name
							text-transform: none

				.asset-colors
					position: absolute
					top: 0
					left: 0
					height: 100%
					width: 3px

					.asset-color
						display: inline-block
						height: 100%
						width: 1px

				.asset-list-item-settings
					position: relative

					.asset-settings
						display: flex
						flex-direction: column
						position: relative
						padding: 5px
						color: #73818f

						&.atlas-settings
							&.atlas-repack-disabled
								opacity: 0.6
								cursor: not-allowed
								>.asset-settings-control
									pointer-events: none

						.asset-settings-control
							display: flex
							justify-content: space-between
							margin-bottom: 10px

						.asset-settings-control:last-child
							margin-bottom: 0

						.loop
							width: 100%

							.title
								display: flex
								height: 22px

							.switch
								margin-right: 0

						.volume-control
							width: 100%

							.custom-range
								width: 200px

						.bitrate
							width: 100%

							.custom-range
								width: 200px

						.link
							color: #20a8d8
							text-decoration: none
							background-color: transparent
							-webkit-transition: 0.2s
							transition: 0.2s
							cursor: pointer

							&:hover
								color: #2080af
								text-decoration: none

					.multi-select-control
						flex-direction: column

						.multi-select-control-item
							display: flex
							flex-direction: row
							justify-content: space-between
							margin-bottom: 10px
							width: 100%

						.title
							padding-top: 4px

						.custom-select
							cursor: pointer
							color: #fff
							width: auto
							background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
							background-color: #343b41
							border: 1px solid #23282c
							margin-top: 0

							&.selected
								background-color: #4dbd74

							&.add
								height: 20px
								line-height: 18px
								padding: 0 10px 0 10px
								background: none
								margin-top: 5px

							&.remove
								height: 20px
								line-height: 18px
								padding: 0 5px 0 5px
								background-image: none
								margin-top: 5px
								display: flex
								justify-content: center
								align-items: center
								margin-left: auto
								margin-right: 5px
								color: #f86c6b

						.form-check-input
							margin-top: 0.1rem

					.asset-settings-control.low-margin
						margin-bottom: 5px

					.asset-settings-control.big-margin
						margin-bottom: 15px

					.asset-settings-control.in-a-row
						flex-direction: row

					.asset-settings-control.separated
						border-top: 1px solid #23282c
						border-bottom: 1px solid #23282c
						padding-top: 5px
						padding-bottom: 5px

					.asset-settings-control.separated-top
						border-top: 1px solid #23282c
						padding-top: 5px
						padding-bottom: 5px

					.asset-settings-info
						display: flex
						justify-content: center
						border-top: 1px solid #23282c
						padding-top: 5px
						border-bottom: 1px solid #23282c
						padding-bottom: 5px
						margin-bottom: 5px

						i.icon-info
							color: #20a8d8
							font-size: 0.8rem !important
							display: inline-block
							margin: 3px 10px

					.control-point
						display: flex
						flex-direction: row
						flex-wrap: nowrap
						align-items: center
						justify-content: right
						font-size: 0.875rem
						width: 180px

						.control-point-input
							display: flex
							flex-direction: row
							flex-wrap: nowrap
							border-radius: 0.1rem
							color: rgba(255, 255, 255, 0.87)
							background-color: rgba(255, 255, 255, 0.05)
							border: 1px solid rgba(255, 255, 255, 0.09)
							transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
							overflow: hidden
							width: 60px
							height: 24px

							label
								display: flex
								flex-direction: row
								flex-wrap: nowrap
								margin: 0
								padding: 0

							.label
								display: flex
								justify-content: center
								width: 20px
								margin-top: -1px
								color: #73818f
								cursor: pointer
								user-select: none
								background-color: rgba(0, 0, 0, 0.05)
								border-right: 1px solid rgba(255, 255, 255, 0.05)

							input
								margin: 0
								width: 35px
								height: 100%
								box-shadow: none
								outline: none !important
								border-radius: 0
								border: none
								background-color: transparent
								padding: 0 3px

						.control-point-input:first-child
							border-top-right-radius: 0
							border-bottom-right-radius: 0

						.control-point-input:nth-child(2)
							border-top-left-radius: 0
							border-bottom-left-radius: 0
							margin-left: -1px
							border-left-color: rgba(255, 255, 255, 0)

						.control-point-input:focus-within
							border-color: rgba(255, 255, 255, 0.18)
							background-color: rgba(255, 255, 255, 0.10)
							color: rgba(255, 255, 255, 0.87)
							outline: none !important
							box-shadow: none

				.asset-list-edit-item
					cursor: pointer
					transition: 0.2s
					padding: 2px 7px
					font-size: 14px
					color: #fff

					&:hover
						color: #20a8d8

					&:last-child
						margin-right: 2px

					&.control-item
						opacity: 0.1

					&.custom
						color: #f86c6b

			.assets-list-item:hover

				.asset-list-edit-item

					&.control-item
						opacity: 1

			.assets-list-item.expanded

				.asset-list-main
					cursor: default

					.asset-list-name

						span
							white-space: normal
							overflow: visible
							height: auto

					.asset-list-edit-item

						&.control-item
							opacity: 1

				.play-on-event-list
					cursor: default

			.assets-list-item.disabled

				.asset-list-main
					color: #73818f

					.asset-list-name
						text-decoration: line-through

		.asset-type-header
			display: flex
			justify-content: space-between

			.asset-type-add
				cursor: pointer
				padding: 0 9px
				font-size: 16px
				transition: 0.2s

				&:hover
					color: #20a8d8

		.progress.add-progress
			height: 5px

		.assets-size
			line-height: 24px
			color: #73818f
			font-size: 12px

	.assets-modal
		background-color: #3a4149
		border-radius: 5px
		box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.6)

		.modal-tabs
			display: flex
			justify-content: space-around
			border-bottom: 1px solid #23282c
			font-weight: 500

			.modal-tab
				padding: 7px 10px
				border-right: 1px solid #23282c
				width: 100%
				text-align: center
				cursor: pointer
				color: #ffffff
				transition: 0.2s
				user-select: none

				&:last-child
					border-right: none
				&:hover
					opacity: 0.8

			.active-modal-tab
				color: #20a8d8
				background-color: #343b41

		.assets-modal-body
			padding: 5px
			height: calc(100% - 35px)

			.assets-modal-stack
				height: 100%
				border-radius: 5px
				border: 1px solid #23282c

				.assets-modal-stack-list
					display: flex
					flex-direction: column
					height: 100%
					overflow-y: auto

					.assets-modal-stack-list-item
						border-bottom: none
						cursor: pointer
						padding: 5px 10px
						border-bottom: 1px solid #23282c
						background-color: #343b41
						transition: 0.2s

						&:first-child
							border-top-left-radius: 5px
							border-top-right-radius: 5px

						&:hover
							opacity: 0.8

					.assets-modal-stack-list-item-active
						background-color: #20a8d8

			.assets-modal-google-fonts
				display: flex
				flex-direction: column
				justify-content: center
				height: 100%

				span
					color: #a1abaf
					font-style: italic

				.assets-modal-google-fonts-description
					width: 80%
					text-align: center
					align-self: center
					margin-bottom: 30px

				.assets-modal-google-fonts-input
					width: 100%
					display: flex
					justify-content: center
					margin-bottom: 30px

					input
						color: #ffffff
						width: 80%
						padding: 8px 15px
						border: 1px solid #23282c
						border-radius: 5px
						outline: none
						background-color: #343b41

				.assets-modal-google-fonts-button
					font-size: 16px
					cursor: pointer
					border-radius: 5px
					border: 1px solid #23282c
					padding: 10px
					background-color: #343b41
					text-align: center
					width: 200px
					align-self: center
					font-weight: 500
					transition: 0.2s
					user-select: none

					&:hover
						box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2)

				.assets-modal-google-fonts-button-disabled
					opacity: 0.5
					cursor: default

					&:hover
						box-shadow: none

</style>
